import { LuxuryResource } from "../types/resources.js";
export const WORLD_CONFIG = {
    /** Number of sectors in each direction (total sectors = gridSize^2) */
    sectorGridSize: 10,
    /** Number of islands per sector */
    islandsPerSector: 4,
    /** Number of city slots per island */
    slotsPerIsland: 16,
    /** Luxury resource distribution weights */
    luxuryDistribution: [
        LuxuryResource.WINE,
        LuxuryResource.MARBLE,
        LuxuryResource.CRYSTAL,
        LuxuryResource.SULFUR,
    ],
};
export const STARTER_RESOURCES = {
    wood: 500,
    wine: 0,
    marble: 0,
    crystal: 0,
    sulfur: 0,
    gold: 200,
};
export const STARTER_BUILDINGS = [
    { position: 0, type: "TOWN_HALL", level: 1 },
];
export const POPULATION_CONFIG = {
    /** Base max population for a new city */
    basePopulation: 40,
    /** Additional population per Town Hall level */
    populationPerTownHallLevel: 30,
    /** Base happiness for a city */
    baseHappiness: 100,
    /** Happiness cost per citizen */
    happinessPerCitizen: 0.5,
    /** Happiness bonus per Tavern level */
    happinessPerTavernLevel: 12,
    /** Happiness bonus per wine load consumed */
    happinessPerWineLoad: 60,
};
export const STORAGE_CONFIG = {
    /** Base storage capacity */
    baseCapacity: 2000,
    /** Multiplier per Warehouse level */
    capacityPerWarehouseLevel: 0.5,
};
export const COMBAT_CONFIG = {
    /** Random damage variance (0.9 to 1.1) */
    damageVarianceMin: 0.9,
    damageVarianceMax: 1.1,
    /** Wall defense bonus per level */
    wallDefenseBonusPerLevel: 0.05,
    /** Loot percentage of defender's resources */
    lootPercentage: 0.3,
    /** Maximum loot limited by carry capacity */
    maxLootByCarry: true,
    /** Beginner protection duration in hours */
    beginnerProtectionHours: 168, // 7 days
};
//# sourceMappingURL=world.js.map